exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-container {\n  height: 150px;\n}\n\n.each-slide > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  height: 150px;\n}", ""]);

// exports
